import React from 'react';
import { Stack } from '@moda/om';
import { formatPrice } from '@moda/portal-stanchions';
import { LineItem } from '../../../hooks/useCart/cart.rest';
import { useLineItemPrices } from '../../../hooks/useLineItemPrices';
import { EstimatedVatLink } from '../../EstimatedVatLink';

import './LineItemPrice.scss';

type Props = {
  direction: 'vertical' | 'horizontal';
  alignItems: 'flex-start' | 'flex-end' | 'center';
  item: LineItem;
  showPriceWithVAT?: boolean;
};

export const LineItemPrice: React.FC<Props> = ({
  showPriceWithVAT,
  direction,
  alignItems,
  item: {
    attributes: {
      isTrunkshow,
      isPreorder,
      isAvailableNow,
      markdownPercentage,
      prices: { originalPrice, currentPrice: currentSinglePrice, depositPrice, isDiscounted },
      quantity,
      vatOnProductPrice,
      promotionApplicableMessage
    }
  }
}) => {
  const {
    discountedPrice,
    originalPriceToShow,
    currentPriceToShow,
    originalPriceWithVAT,
    currentPrice
  } = useLineItemPrices(
    currentSinglePrice,
    quantity,
    originalPrice,
    markdownPercentage,
    vatOnProductPrice,
    showPriceWithVAT,
    promotionApplicableMessage,
    isDiscounted
  );
  return (
    <Stack space={1} alignItems={alignItems}>
      <Stack className="LineItemPrice" space={1} direction={direction} data-testid="lineItemPrice">
        <Stack space={1} direction={direction}>
          {originalPrice.price != discountedPrice && (
            <div data-testid="lineItemOriginalPrice" className="LineItemPrice__original">
              {originalPriceToShow}
            </div>
          )}
          <div data-testid="lineItemCurrentPrice">{currentPriceToShow}</div>
        </Stack>

        {(isTrunkshow || isPreorder) && !isAvailableNow && (
          <div data-testid="lineItemDepositPrice">
            ({formatPrice(depositPrice.currency, depositPrice.price)} Deposit)
          </div>
        )}
        {isDiscounted && (
          <div data-testid="lineItemMarkdownPercentage" className="LineItemPrice__markdown-percent">
            Save {Math.floor(Number(markdownPercentage))}%
          </div>
        )}
      </Stack>
      {Number(vatOnProductPrice.price) !== 0 && (
        <EstimatedVatLink
          currentPrice={showPriceWithVAT === true ? originalPriceWithVAT : currentPrice}
          vatPrice={vatOnProductPrice}
        />
      )}
    </Stack>
  );
};
